module.exports = __webpack_public_path__ + "media/images/document-c7638de8.png";